import template from './wizard_departments.html';

class WizardDepartmentsViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	};

	back_wizard()
	{
		Grape.dialog.open('WizardCompaniesEntry', {});
		this.dialog.close();
	};
	
	next_wizard()
	{
		Grape.dialog.open('WizardFinishBasic', {});
		this.dialog.close();
	};
};

class WizardDepartmentsPage
{
	constructor (bindings)
	{
		this.viewModel = new WizardDepartmentsViewModel(this);
		this.bindings = bindings;
	};
};

export default {
	name: 'WizardDepartmentsEntry',
	dialog_class: WizardDepartmentsPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_departments',
	provider: 'ps'
};
